import { render, staticRenderFns } from "./deductible-detail.vue?vue&type=template&id=0995a1aa&scoped=true"
import script from "./deductible-detail.vue?vue&type=script&lang=js"
export * from "./deductible-detail.vue?vue&type=script&lang=js"
import style0 from "./deductible-detail.vue?vue&type=style&index=0&id=0995a1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0995a1aa",
  null
  
)

export default component.exports